import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Help = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Help' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M12,23 C12.5522847,23 13,22.5522847 13,22 C13,21.4477153 12.5522847,21 12,21 C11.4477153,21 11,21.4477153 11,22 C11,22.5522847 11.4477153,23 12,23 Z M12,18 L12,15 C12,13 13,13 15,12 C17,11 18,9.15767339 18,7 C18,3.6862915 15.3137085,1 12,1 C8.6862915,1 6,3.6862915 6,7' />
  </StyledIcon>
);
